import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@fortawesome/fontawesome-free/css/all.css';
import type { UserVuetifyPreset } from 'vuetify';

Vue.use(Vuetify);
const opts: UserVuetifyPreset = {
    icons: {
        iconfont: 'fa',
    },
    theme: {
        themes: {
            light: {
                primary: '#89a0ca',
            },
        },
    },
};
export default new Vuetify(opts);
